export default {
  data() {
    return {
      imageLoadComplete: false
    }
  },
  methods: {
    onImageLoad() {
      this.imageLoadComplete = true
    }
  }
}
